import RequestBase from "./RequestBase.ts";

export default class UsersRequests extends RequestBase {
    constructor(){
        super("PanelUsers/");
    }

    ResetPassword = (userId, onSuccess) => 
    {
        this.defaultAxios.post(`ResetPassword/${userId}`, {})
        .then((res) => 
        {
            onSuccess(res.data);
        })
    }
}